/**
 * Chip styling for a protocol version's lifecycle status.
 *
 * Tone is conveyed by BOTH colour and a text label (never colour-only — NHS
 * a11y rule). Colours resolve to semantic `--color-tone-*` / surface tokens
 * declared in frontend/src/design/tokens.css — zero hardcoded hex.
 *
 * draft       → muted (not yet in force)
 * in_review   → muted (submitted; an approval process holds it)
 * published   → ok    (in force)
 * archived    → warn  (out of force; still visible for audit)
 */

import type { ProtocolVersionStatus } from '@/api/protocols'

/** Tailwind classes for the chip container (border + text colour) per status;
 *  the label is `alg.manage.status.<status>`. */
export const STATE_CHIP_CLASS: Record<ProtocolVersionStatus, string> = {
  published: 'border-[var(--color-tone-ok)]/40 text-[var(--color-tone-ok)]',
  archived: 'border-[var(--color-tone-warn)]/40 text-[var(--color-tone-warn)]',
  in_review: 'border-[var(--color-surface-border)] text-[var(--color-surface-mute)]',
  draft: 'border-[var(--color-surface-border)] text-[var(--color-surface-mute)]',
}
